<script setup>
import { useAccountStatusIssues } from '~/account/composables/useAccountStatusIssues'

const { issues } = useAccountStatusIssues()
const hasIssues = computed(() => issues.value?.some(issue => issue.type === 'missing_membership_payment_method'))
</script>

<template>
  <MainContainer v-if="hasIssues">
    <div class="mx-4 flex flex-col flex-gap-y-4">
      <template
        v-for="issue in issues"
        :key="issue.type"
      >
        <AppMissingMembershipPaymentMethodBanner
          v-if="issue.type === 'missing_membership_payment_method'"
          :action-url="issue.action_url"
          :data="issue.data"
        />
      </template>
    </div>
  </MainContainer>
</template>
